import { ProductHelper } from '..';

export const useProduct = () => {
	let productHelper = new ProductHelper();
	return {
		productHelper,
		activeProduct: productHelper.active()
	};
};
